export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/d8d773ec4169f3174e1b.worker.js");
}
